var React = require('react');

function Relic (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"points":"55,93.5 27.1,65.6 55,37.7 59.2,41.9 35.6,65.6 59.2,89.3 ","key":1}),React.createElement("rect",{"x":"31","y":"63","width":"52","height":"6","key":2}),React.createElement("polygon",{"points":"95,112.3 90.8,108.1 114.4,84.4 90.8,60.7 95,56.5 122.9,84.4 ","key":3}),React.createElement("rect",{"x":"67","y":"81","width":"52","height":"6","key":4})]);
}

Relic.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 150 150","style":{"enableBackground":"new 0 0 150 150"},"xmlSpace":"preserve"};

module.exports = Relic;

Relic.default = Relic;
